var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDurasiSewaFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#009EF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 10.3333V14.3333L14.8 16.2667L15.3333 15.4667L12.6667 13.8667V10.3333H11.6667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9467 13C17.0472 13.6626 17.0029 14.3392 16.8168 14.983C16.6307 15.6269 16.3073 16.2228 15.8689 16.7296C15.4304 17.2365 14.8873 17.6424 14.277 17.9192C13.6666 18.1961 13.0035 18.3373 12.3333 18.3333C9.73334 18.3333 7.66668 16.2667 7.66668 13.6667C7.66668 11.0667 9.73334 9.00001 12.3333 9.00001C12.8 9.00001 13.2467 9.06667 13.6667 9.19334V7.82001C13.24 7.72001 12.7933 7.66667 12.3333 7.66667C9.00001 7.66667 6.33334 10.3333 6.33334 13.6667C6.33334 17 9.00001 19.6667 12.3333 19.6667C13.1785 19.6702 14.0147 19.4944 14.7869 19.1509C15.5591 18.8073 16.2496 18.3039 16.8128 17.6739C17.3761 17.0438 17.7993 16.3015 18.0545 15.4958C18.3097 14.6901 18.3911 13.8395 18.2933 13H16.9467Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 8.33333V6.33333H17V8.33333H15V9.66666H17V11.6667H18.3333V9.66666H20.3333V8.33333H18.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurasiSewaFilledIcon);
export default __webpack_public_path__ + "static/media/durasi-sewa-filled-icon.af7579f6c9064e1cbf92584164072135.svg";
export { ForwardRef as ReactComponent };